import { z } from "zod";
import { zArr, zBool, zNum, zObj, zOptional, zStr } from "./zodWrapper.js";
export var SourceKey;
(function (SourceKey) {
    SourceKey["SENSORDATA"] = "sensordata";
    SourceKey["MLDATA"] = "mldata";
})(SourceKey || (SourceKey = {}));
export const SourceKeyEnum = z.nativeEnum(SourceKey);
export var AggregationMethod;
(function (AggregationMethod) {
    AggregationMethod["PREDICTION"] = "baseline_raw";
    AggregationMethod["SNAP_FIRST"] = "snap_first";
    AggregationMethod["AVG_LAST_REPUB"] = "snap_mean";
    AggregationMethod["MIN_LAST_REPUB"] = "snap_min";
    AggregationMethod["MAX_LAST_REPUB"] = "snap_max";
    AggregationMethod["BASELINE_ACCURACY_PERCENTAGE"] = "baseline_accuracy_percentage";
    AggregationMethod["ACCUMULATED"] = "accumulated";
})(AggregationMethod || (AggregationMethod = {}));
export const AggregationMethodEnum = z.nativeEnum(AggregationMethod);
export const Signal = zObj({
    sourceKey: SourceKeyEnum,
    sensorId: zNum(),
    aggregationMethod: AggregationMethodEnum,
});
export const TimeseriesInterval = zObj({ from: zStr(), to: zStr() });
export const TimeseriesArgs = zObj({
    signals: zArr(Signal),
    interval: zOptional(TimeseriesInterval),
    numSamples: zOptional(zNum()),
    orderAsc: zOptional(zBool()),
});
export const TimeseriesDataPoint = zObj({
    timestamp: zStr(),
    value: zNum(),
    state: zOptional(zStr()),
});
export const Timeseries = zObj({
    sensorId: zNum(),
    aggregationMethod: AggregationMethodEnum,
    dataPoints: zArr(TimeseriesDataPoint),
});
export const TimeseriesCollection = zArr(Timeseries);
export const SensorSignal = zObj({
    topic: zStr(),
    aggregationMethod: AggregationMethodEnum,
});
export const SensorAggrMethod = zObj({
    sensorId: zNum(),
    aggregationMethod: AggregationMethodEnum,
});
export const GetLiveDataArgs = zObj({ sensors: zArr(SensorAggrMethod) });
export var Trend;
(function (Trend) {
    Trend["UP"] = "\u279A";
    Trend["STEADY"] = "\u2799";
    Trend["DOWN"] = "\u2798";
    Trend["NONE"] = "";
})(Trend || (Trend = {}));
export const TrendEnum = z.nativeEnum(Trend);
export const LiveData = zObj({
    sensorId: zNum(),
    aggregationMethod: AggregationMethodEnum,
    value: TimeseriesDataPoint,
    trend: zOptional(TrendEnum),
});
export const LiveDatas = zArr(LiveData);
export const GetLastSensorChangeArgs = zObj({ sensorIds: zArr(zNum()) });
export const LastSensorChange = zObj({ sensorId: zNum(), timestamp: zStr() });
export const LastSensorChanges = zArr(LastSensorChange);
//# sourceMappingURL=timeseries.js.map